import { css } from '@emotion/react';

export const LoadingStyle = css`
    display: block;
    margin: 0 auto;
    border-color: red;
`;
 